import useGlobalContext from "hooks/globalData";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ResponseCode } from "services/KnowfullyAdminClient";
import ConfirmDialog from "components/ConfirmDialog";

type CloneSkuConfirmationDialogProps = {
  skuId?: string;
  close: () => void;
};

export default function CloneSkuConfirmationDialog({
  skuId,
  close,
}: CloneSkuConfirmationDialogProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { skuDetailsUrl, skuService } = useGlobalContext();

  const cloneSku = async () => {
    if (!skuId) {
      return;
    }

    const skuResponse = await skuService.cloneSku(skuId);
    queryClient.invalidateQueries("skusList");

    if (skuResponse.responseCode !== ResponseCode.OK) {
      throw new Error(skuResponse.responseReason);
    }

    navigate(skuDetailsUrl(skuResponse.data?.id));
  };

  return (
    <ConfirmDialog
      dialogTitleKey="skuCloneLabel"
      contentKey="skuCloneConfirmationMessage"
      confirmLabel="confirmButton"
      open={!!skuId}
      onCancel={close}
      handleConfirm={cloneSku}
    />
  );
}
